import React, { useState } from "react";
import { BrowserRouter, Route, Routes, useLocation } from "react-router-dom";
import AuthProvider from "./Context/AuthContext";

import ProfileCardPage from "./Page/ProfileCard/ProfileCardPage";

const Loader = () => {
  return <div className="loader"></div>;
};

const MainContent = () => {
  const [loading] = useState(false);
  const location = useLocation();

  return (
    <>
      {loading && <Loader />}
      {!loading && (
        <Routes>
          {/* Root page */}
          <Route path="/" element={<ProfileCardPage />} />

          {/* Dynamic id page */}
          <Route path=":id" element={<ProfileCardPage />} />
        </Routes>
      )}
    </>
  );
};

const Router = () => {
  return (
    <AuthProvider>
      {/* basename is derived from CRA's PUBLIC_URL (set from package.json's
          "homepage" at build time) instead of a second hardcoded literal —
          a mismatch between the two (e.g. "/profile-card" vs the actually
          deployed "/profile-cards") makes every route fail to match with no
          console error at all, just a blank page. */}
      <BrowserRouter basename={process.env.PUBLIC_URL || "/"}>
        <MainContent />
      </BrowserRouter>
    </AuthProvider>
  );
};

export default Router;